import { feedback } from '@ecosystem/newron-design-system';
import { WithAlert } from '@components/design';

const { ActionType } = feedback;

export const ErrorResultMessage = () => {
  return (
    <div className="my-4">
      <WithAlert
        title="No results available for the options selected. Try adjusting some filters to narrow down your selection and return a smaller dataset."
        type="info"
        actionType={ActionType.DEFAULT}
      />
    </div>
  );
};

export default ErrorResultMessage;
